export default "__VITE_ASSET__Dvilj2jW__"